import {
	CLOSE_CONFIRMATION_FAIL,
	CLOSE_CONFIRMATION_SUCCESS,
	SET_CONFIRMATION_FAIL,
	SET_CONFIRMATION_SUCCESS,
} from './types';

const initialState = {
	// isOpen: false,
	confirmationDetails: {},
	deleteLead: false,
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_CONFIRMATION_SUCCESS:
			return {
				...state,
				// isOpen: true,
				confirmationDetails: payload.details,
				deleteLead: payload['deleteLead']
					? payload['deleteLead']
					: false,
				startAgreement: payload['startAgreement']
					? payload['startAgreement']
					: false,
				deletePurchaser: payload['deletePurchaser']
					? payload['deletePurchaser']
					: false,
				deleteDocument: payload['deleteDocument']
					? payload['deleteDocument']
					: false,
				editLeads: payload['editLeads'] ? payload['editLeads'] : false,
				closeAgreement: payload['closeAgreement']
					? payload['closeAgreement']
					: false,
				deleteUsers: payload['deleteUsers']
					? payload['deleteUsers']
					: false,
				archiveUsers: payload['archiveUsers']
					? payload['archiveUsers']
					: false,
				unarchiveUsers: payload['unarchiveUsers']
					? payload['unarchiveUsers']
					: false,
				deleteRoles: payload['deleteRoles']
					? payload['deleteRoles']
					: false,
				completeExtraForm: payload['completeExtraForm']
					? payload['completeExtraForm']
					: false,
				loading: false,
			};
		case SET_CONFIRMATION_FAIL:
			return {
				...state,
				isOpen: false,
				confirmationDetails: {},
				loading: false,
			};

		case CLOSE_CONFIRMATION_SUCCESS:
		case CLOSE_CONFIRMATION_FAIL:
			return {
				...state,
				// isOpen: false,
				confirmationDetails: {},
				deleteLead: false,
				startAgreement: false,
				deletePurchaser: false,
				deleteDocument: false,
				editLeads: false,
				closeAgreement: false,
				deleteUsers: false,
				archiveUsers: false,
				unarchiveUsers: false,
				deleteRoles: false,
				completeExtraForm: false,
				loading: false,
			};

		default:
			return state;
	}
}
